const styles = theme => ({
    container:{
        maxWidth: '1600px',
        margin: 'auto',
        minHeight: 'calc(100vh - 234px)',
    },
    instructions:{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start'

    },
    leftPadding : {
        padding: '10px 0px 10px 20px',
        display: 'flex',
        flexDirection: 'row',
        wordWrap: 'break-word',
        textAlign: 'left',
    },
    extraInstructions:{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        margin: '0px 0px 0px 20px',
        fontFamily: 'AvenirNext',
        fontSize: '15px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#3b3b3b',
        textAlign: 'left',
        wordWrap: 'break-word',
    }
});

export default styles;


